import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
	{
		path: '/adminlogin',
		name: 'AdminLogin',
		component: () => import('@/views/admin/login.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/adminpay',
		name: 'AdminPay',
		component: () => import('@/views/status/expiration.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/register',
		name: 'registerBox',
		component: () => import('@/views/login/login/register.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/forget',
		name: 'forgetBox',
		component: () => import('@/views/login/login/forget.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/login',
		name: 'Login',
		component: () => import('@/views/login/login.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/index/createStore',
		name: 'indexCreateStore',
		component: () => import('@/views/index/createStore.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/index/createStore_user',
		name: 'indexCreateStoreUser',
		component: () => import('@/views/index/createStore_user.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/apply/login',
		name: 'applyLogin',
		component: () => import('@/views/registerWechatMp/login.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: () => import('@/views/agreement/agreement.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/apps',
		name: 'Apps',
		component: () => import('@/views/apps/apps.vue'),
		meta: {
			layout: false
		}
	},
	{
		path: '/arealogin',
		name: 'arealogin',
		component: () => import('@/views/apps/haowu/login.vue'),
		meta: {
			layout: false
		}
	},
]

const createRouter = () => new VueRouter({
	mode: 'hash',
	routes
})

const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher
}

export default router
